import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';
import { queryKeys } from '@/api/query-client';
import type { paths } from '@/api/generated/schema';

type QueryOf<TPath extends keyof paths> = NonNullable<
  paths[TPath] extends { get: { parameters: { query?: infer TQuery } } } ? TQuery : never
>;

export type UsersQuery = QueryOf<'/api/v1/users'>;

/** Utilisateurs du compte, pour l'onglet « Équipe » des paramètres. */
export function useUsers(params: UsersQuery = {}) {
  return useQuery({
    queryKey: queryKeys.users(params),

    queryFn: async () => {
      const { data } = await api.GET('/api/v1/users', { params: { query: params } });

      return data!;
    },
  });
}

/** Établissements du compte. */
export function useEstablishments() {
  return useQuery({
    queryKey: queryKeys.establishments(),

    queryFn: async () => {
      const { data } = await api.GET('/api/v1/establishments');

      return data!;
    },
  });
}
